import $ from 'jquery';

const $button = $('#id_head_search_btn'),
    $input = $('#id_head_search_input'),
    $form = $('#id_head_search_form');

if ($button.length) {
    $button.click(function (e) {
        e.preventDefault();
        $form.slideToggle();
        $input.focus();
    });
    $('.search-close').click((e) => {
        e.preventDefault();
        $form.slideUp();
    });
}



// WEBPACK FOOTER //
// ./js/common/search.js